import { IUser } from "~/types/user"

export type OsModule = "accountOS" | "rfpOS" | "marketingOS" | "agentOS"

export function getVisibleOsModules(
  featureFlags: IUser["feature_flags"] | undefined,
  isOsLite: boolean
): OsModule[] {
  const showOnlyRfp = featureFlags?.show_only_rfp
  const showRfpFirst = featureFlags?.show_rfp_first
  const hideRfpOS = featureFlags?.hide_rfp_os
  const enableOnlyMarketingOS = featureFlags?.enable_only_marketing_os

  let arr: OsModule[] = ["accountOS", "rfpOS"]

  if (showOnlyRfp) {
    arr = ["rfpOS"]
  }
  if (showRfpFirst) {
    arr = ["rfpOS", "accountOS"]
  }
  if (hideRfpOS) {
    arr = arr.filter((name) => name !== "rfpOS")
  }

  if (featureFlags?.inside_sales_enabled || isOsLite) {
    arr.push("marketingOS")
  }

  if (enableOnlyMarketingOS) {
    arr = ["marketingOS"]
  }

  if (featureFlags?.agent_os_enabled) {
    arr.push("agentOS")
  }

  return arr
}
